import { render, staticRenderFns } from "./applicant-joining-data.vue?vue&type=template&id=dfff14ca&scoped=true"
import script from "./applicant-joining-data.vue?vue&type=script&lang=js"
export * from "./applicant-joining-data.vue?vue&type=script&lang=js"
import style0 from "./applicant-joining-data.vue?vue&type=style&index=0&id=dfff14ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfff14ca",
  null
  
)

export default component.exports